import React from 'react';

import classNames from 'classnames';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

import { render } from 'react-dom';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import {withRouter} from 'react-router-dom'




const styles = theme => ({
    appBar: {
        marginBottom: '25px',
    },
    root: {
        flexGrow: 1,
        marginBottom: '50px',
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        paddingBottom: '250px',
    },
});

class ClassSelector extends React.Component {
    state = {
    };

    render() {
        const { classes, classList, colorsList } = this.props;

        return (
            <div className={classes.root}>
                <Paper>
                    <AppBar position='static' className={classes.appBar}>
                        <Toolbar>
                            <Typography variant="title" color="inherit" className={classes.flex}>Class Selector</Typography>
                        </Toolbar>
                    </AppBar>

                    <Grid container className={classes.gridContainer} spacing={16}>
                        {classList && classList.map((cl, i) => {
                            return (
                            <Grid item xs={4}>
                                <Button
                                    variant="contained"
                                    onClick={() => this.props.setLabel(cl)}
                                    style={{
                                        backgroundColor: colorsList[i],
                                        color: "#ffffff"
                                    }}
                                >{cl}</Button>
                            </Grid>
                            )})}
                    </Grid>
                </Paper>
            </div>
        );
    }
}

export default withRouter(withStyles(styles)(ClassSelector));



// WEBPACK FOOTER //
// ./src/components/labeler/class_selector.jsx